<script>
	import { onMount } from "svelte";
	import { navigate } from "svelte-routing";
	import { Button, Col, Row } from "sveltestrap";
	import queryString from "query-string";
	import client from "../../../../services/client";
	import {
		errorMessage,
		totalPages,
		loading,
		loadingStatus,
	} from "../../../../store/store";
	import VehiclePhotoTable from "./VehiclePhotoTable.svelte";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import FilterForm from "../../../../components/FilterForm/FilterForm.svelte";
	import { extractErrorMessage } from "src/utils/misc";

	let data = [];

	//Start Logic for filter feature
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	let queryParams = `?page=1&size=100`;
	let searchParams = window.location.search.toString();
	let queryPage = searchParams.includes("page");
	let queryvehicleModel = searchParams.includes("carModel");
	let queryvehicleMake = searchParams.includes("carMake");
	let queryvehicleColor = searchParams.includes("carColor");

	if (queryPage) {
		queryParams = `?page=${params.page}&size=100`;
	}
	if (queryvehicleMake) {
		queryParams = queryParams.concat(`&MakeID=${params.carMake}`);
	}
	if (queryvehicleModel) {
		queryParams = queryParams.concat(`&ModelID=${params.carModel}`);
	}
	if (queryvehicleColor) {
		queryParams = queryParams.concat(`&ColorID=${params.carColor}`);
	}

	//End Logic for filter feature

	//FETCH Vehicle LIST
	onMount(async () => {
		try {
			loading.set(true);
			const res = await client(`/v1/photos/filter${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res.data.dataList;
			totalPages.set(res.data.totalPage);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err.response);
			extractErrorMessage(err);
			// errorMessage.set(err.response.data.errors[""]["0"]);
		}
	});

	async function refreshData(limit) {
		try {
			if (limit == "delete") {
				loading.set(true);
			} else {
				loadingStatus.set(true);
			}
			const res = await client(`/v1/photos/filter${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res?.data?.dataList;
			totalPages.set(res?.data?.totalPage);
			if (res.data.data.dataList) {
				if (limit == "delete") {
					loading.set(false);
				} else {
					loadingStatus.set(false);
				}
			}
			// console.log(files);
		} catch (err) {
			if (limit == "delete") {
				loading.set(false);
			} else {
				loadingStatus.set(false);
			}
			console.log(err.response);
			extractErrorMessage(err);
			// errorMessage.set(err.response.data.errors[""]["0"]);
		}
	}

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Vehicle Photos Data" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm carMake carModel vehicleColor />
				</Col>
				<Col class="d-flex justify-content-end" xs={6}>
					<div class="mx-2">
						<Button
							class="themeButton primary px-4"
							on:click={() =>
								navigate(
									"/master-data/vehicle-data/vehicle-photos/create"
								)}>CREATE</Button
						>
						<!-- <div class="mt-5">
							<SizeSelect />
						</div> -->
					</div>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<VehiclePhotoTable {data} {refreshData} />
	</Col>
</Row>
